module.exports = __webpack_public_path__ + "img/26.4e0cffa1.png";